import { render, staticRenderFns } from "./ehsMenuPage.vue?vue&type=template&id=3ac2c5e8&"
import script from "./ehsMenuPage.vue?vue&type=script&lang=js&"
export * from "./ehsMenuPage.vue?vue&type=script&lang=js&"
import style0 from "./ehsMenuPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports